import { Route, Routes } from 'react-router-dom';

// Bootstrap Components.
import { Container } from 'reactstrap';

// Custom Components.
import MainPage from './pages/MainPage';
import BetaRolesPage from './pages/BetaRolesPage';
import FAQPage from './pages/FAQPage';
import VerifyPage from './pages/VerifyPage';
import { ThemeProvider } from './context/ThemeContext';

import './App.css';
import RoutePage from './components/layout/RoutePage';

const routes = [{
  url: '/faq',
  componentRenderer: <RoutePage ContentRenderer={FAQPage} />
}, {
  url: '/beta-roles',
  componentRenderer: <RoutePage ContentRenderer={BetaRolesPage} />
}, {
  url: '/*',
  componentRenderer: <RoutePage ContentRenderer={MainPage} />
}, {
  url: '/verify',
  componentRenderer: <RoutePage ContentRenderer={VerifyPage} />
}];

function App() {
  return (
    <ThemeProvider>
      <Container fluid className="app-shell px-0">
        <Routes>
          {routes.map(({ url = '', componentRenderer = () => null }) => (
            <Route key={`page-route-${url}`} path={url} element={componentRenderer} />
          ))}
        </Routes>
      </Container>
    </ThemeProvider>
  );
};

 export default App;
